import React from 'react';
import { useGetCustomer } from '../../hooks/apolloHooks/useGetCustomer';
import { GET_BASIC_CUSTOMER_DATA_QUERY } from '../../integrations/allkort/graphql/gql/CustomerQueries';
import { BasicCustomerDataResponse } from '../../integrations/allkort/graphql/interface/Customer';
import ErrorDisplay from '../elements/ErrorDisplay';
import TransactionHeader from '../views/Transactions/TransactionHeader';
import TransactionsTable from '../views/Transactions/TransactionsTable';


// TransactionsPage fetches its own data - no props needed
const TransactionsPage: React.FC = () => {
	const transactionWrapperClasses = 'white-pale-section shadow-one';

	// Fetch customer basic data
	const { data: customerBasicData, loading: customerLoading, error: customerError } = useGetCustomer<BasicCustomerDataResponse>(
		GET_BASIC_CUSTOMER_DATA_QUERY,
		undefined
	);

	// TODO: handle loading state properly
	if (customerLoading) {
		return (
			<div className="loading-page">
				<span className="loader-zoom">
				</span>
			</div>
		);
	}
	if (customerError) return <ErrorDisplay errorContext="Fel vid laddning av kunddata:" errorMessage={customerError.message} />

	return (
		<>
			<div className="Section transactions-page-component">
				<div className="Row Row--JustifyLeft">
					<TransactionHeader
						wrapperClasses={transactionWrapperClasses}
						customerData={customerBasicData?.currentCustomer}
					/>

					<TransactionsTable
						wrapperClasses={transactionWrapperClasses}
						isCompany={customerBasicData?.currentCustomer?.isCompany ?? false}
					/>

				</div>
			</div>
		</>

	)
}
export default TransactionsPage
